import { IPaymentMethod } from "@features/summary/interface/IPaymentMethod";
import { EPaymentCardType, ISimplePaymentMethodCard } from "@common/SimplePaymentMethodCardList";

export const getSimplePaymentMethodCardList = (paymentMethodList: IPaymentMethod[]): ISimplePaymentMethodCard[] =>
    paymentMethodList.map((paymentMethod) => ({
        providerReference: paymentMethod.providerReference,
        partialDigits: paymentMethod.partialDigits,
        cardholderName: paymentMethod.cardholderName,
        expirationDate: paymentMethod.expirationDate,
        creditCardType: paymentMethod.type as EPaymentCardType,
    }));
